import AboutMeComponent from "../components/AboutMeComponent";

const AboutMe = () => {

    return  <AboutMeComponent/>
}

export default AboutMe;